import getTabIdFromProjection from 'owa-popout-v2/lib/utils/getTabIdFromProjection';
import { MAIN_WINDOW_ID } from '../constants/constants';

export default function getTabIdFromWindow(targetWindow: Window = window): string {
    const tabId = getTabIdFromProjection(targetWindow);

    return tabId ? tabId : MAIN_WINDOW_ID;
}
